export class Accordions {
	el: Element

	constructor(el) {
		this.el = el
		this.init()
	}

  init() {
    const accordionControls = this.el.querySelectorAll('[data-toggle="accordion"]');
    
    accordionControls.forEach((control: HTMLElement) => {
      control.addEventListener('click', () => {
        const content = control.nextElementSibling as HTMLElement;
        if (content && content.style.maxHeight) {
          content.style.maxHeight = '';
          control.classList.remove('is-opened');
          control.setAttribute('aria-expanded', 'false');
        } else if (content) {
          content.style.maxHeight = content.scrollHeight + 'px';
          control.classList.add('is-opened');
          control.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

}